import { styled } from "@mui/material/styles";
import { Avatar } from "@mui/material";

const UserBoxMain = styled("div")(({ theme }) => ({
  width: "30%",
  border: "1px solid #E1E1E1",
  height: "90vh",
}));
const UserItmeMain = styled("div")(({ theme }) => ({
  //   padding: "10px",
  height: "100%",
  "& .Nouser": {
    textAlign: "center",
    marginTop: "10px",
    textTransform: "capitalize",
    fontFamily: theme.typography.Nunito,
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#0B0B0B",
  },
}));

const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "48px",
  height: "48px",
  backgroundColor: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));

const UserItmeWrap = styled("div")(({ theme }) => ({
  display: "flex",
  gap: "5px",
  padding: "10px",
  cursor: "pointer",
  alignItems: "center",
  "&.active": {
    background: "#E1E1E1",
  },
  "& .userprofile": {
    margin: "auto 0",
  },
}));
const Userdetails = styled("div")(({ theme }) => ({
  paddingLeft: "5px",
  marginRight: "auto",
  "& h6": {
    fontFamily: theme.typography.Nunito,
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#0B0B0B",
  },
  "& p": {
    fontFamily: theme.typography.Nunito,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "rgba(11, 11, 11, 0.5)",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: "2",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));
const Usertime = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  height: "100%",
  "& span.count": {
    fontFamily: theme.typography.Nunito,
    background: "#0B0B0B",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "13px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#FFFFFF",
    justifyContent: "center",
    margin: "auto",
    marginBottom: "20px",
  },
  "& .time": {
    // paddingTop: "10px",
    fontFamily: theme.typography.Nunito,
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#0B0B0B",
  },
}));

export {
  UserBoxMain,
  UserItmeMain,
  UserAvatar,
  UserItmeWrap,
  Userdetails,
  Usertime,
};
